<template>
  <div class="my-collect">
    <pageHeader title="我的收藏" />

    <div class="collect-container">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="暂无更多数据"
        @load="onLoad"
      >
        <div class="game-item" v-for="(info, indexb) in gameList" :key="indexb">
          <div class="game-item-content" @click="jumpDetail(info)">
            <img class="game-logo" :src="info.logo_url" alt="" />
            <div class="game-info">
              <div class="game-info-title">
                <h1>{{ info.game_name }}</h1>
                <span>{{ info.discount }}</span>
              </div>
              <div class="game-info-desc">
                <div class="game-info-gift">
                  <span v-if="info.wealf">福利</span>
                  <span v-if="!info.wealf && info.havaGift == 1">礼包</span>
                  <span v-if="info.isBTgame">变态特权</span>
                  <span v-if="info.waterMark == 1">专属折扣</span>
                  <span
                    v-if="
                      info.havaGift == 0 &&
                      !info.isBTgame &&
                      !info.wealf &&
                      info.waterMark == 0
                    "
                    >{{ info.title }}</span
                  >
                </div>
                <div class="star" v-if="info.starInfo">
                  <img
                    :key="star"
                    v-for="star in info.starInfo.allStar"
                    src="@/assets/images/star_all.png"
                    alt=""
                  />
                  <img
                    :key="star + 999"
                    v-for="star in info.starInfo.halfStar"
                    src="@/assets/images/star_half.png"
                    alt=""
                  />
                </div>
              </div>
              <div class="game-tag">
                <span v-for="tag in info.formatGameType" :key="tag">{{
                  tag
                }}</span>
                <span class="other-tag">{{ info.openServerDate }}</span>
              </div>
            </div>
          </div>
          <div class="game-item-operate">
            <span @click="collectHandle(info)">{{info.isCollect ? '已收藏' : '收藏'}}</span>
            <span @click="doOperate(info, 'recharge')">充值</span>
          </div>
        </div>
      </van-list>
    </div>

    <gamePlatPopup
      v-if="gamePlatPopupVisible"
      v-model="gamePlatPopupVisible"
      :btnType="btnType"
      :gameInfo="gameInfo"
    ></gamePlatPopup>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import { requestMethods } from "@m/api";
import gamePlatPopup from "@/components/GamePlatPopup.vue";
import { mapGetters } from "vuex";
import mixins from "@/mixin/game.js";
export default {
    mixins: [
        mixins
    ],
  components: {
    pageHeader,
    gamePlatPopup,
  },
  data() {
    return {
      gameList: [],
      loading: false,
      finished: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      btnType: "",
      gameInfo: {},
      gamePlatPopupVisible: false,
    };
  },
  computed: {
    ...mapGetters(["uuid", "isLogin"]),
  },
  methods: {
    async onLoad() {
      this.loading = true;
      const { data, totalCount } = await this.getGameCollectList();

      this.gameList = [...this.gameList, ...data];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize);
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },

    /**
     * 根据分类查询游戏列表
     */
    async getGameCollectList() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/web/game/getGameCollectList.htm",
          "post",
          {
            uuid: this.uuid,
            appType: "WM",
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          }
        );
        let arr = data.map(e => {
          return {
            isCollect: true,
            ...e
          }
        })
        let list = this.gameInit(arr);
        return {
          data: list,
          totalCount: totalCount,
        };
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    doOperate(scope, chennel) {
      if(!this.isLogin) {
        this.$router.push('/login')
        return
      }
      this.btnType = chennel == "recharge" ? "00" : "01";
      this.gameInfo = {
        gameName: scope.game_name,
        gameId: scope.game_id
      }
      this.gamePlatPopupVisible = true;
    },

    /**
     * 收藏取消收藏
     */
    collectHandle(info) {
      if(info.isCollect) {
        this.unclooect(info)
        info.isCollect = !info.isCollect
      } else {
        this.collect(info)
        info.isCollect = !info.isCollect
      }
    },

    async collect(info) {
      try {
        await requestMethods(
          "/modules/collect/gameCollect/saveOrUpdate.htm",
          "post",
          {
            gameId: info.game_id,
            uuid: this.uuid,
            appType: "WM",
          }
        );
        this.$toast('收藏成功');
      } catch (error) {
        this.$toast(error.message);
      }
    },
    async unclooect(info) {
      try {
        await requestMethods(
          "/modules/collect/gameCollect/delete.htm",
          "post",
          {
            gameId: info.game_id,
            uuid: this.uuid,
            appType: "WM",
          }
        );
        this.$toast('已取消收藏');
      } catch (error) {
        this.$toast(error.message);
      }
    },

    jumpDetail(info) {
      this.$router.push({ path: '/detail', query: { gameId: info.game_id } })
    }
  },
};
</script>

<style lang="scss" scoped>
.my-collect {
  min-height: 100vh;
  background: #f5f5f5;
  .collect-container {
    

    .game-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      padding: 40px;
      background: #fff;
      &:last-child {
        margin-bottom: 0;
      }
    }

    .game-item-content {
      display: flex;
      align-items: center;

      .game-logo {
        width: 132px;
        height: 132px;
        margin-right: 20px;
      }
      .game-info {
        .game-info-title {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          h1 {
            max-width: 300px;
            font-weight: 600;
            font-size: 32px;
            color: #000000;
            line-height: 45px;
            margin-right: 6px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          span {
            display: block;
            padding: 5px 5px;
            font-weight: 600;
            font-size: 22px;
            color: #ffffff;
            height: 30px;
            background: #ff7a3e;
            border-radius: 4px;
          }
        }
        .game-info-desc {
          width: 390px;
          display: flex;
          align-items: center;
          margin-bottom: 12px;

          .game-info-gift {
            span {
              padding: 4px 12px;
              background: #f8f8f8;
              border-radius: 4px;
              border: 1px solid #f8f8f8;
              font-weight: 500;
              font-size: 18px;
              color: #a2a2a2;
              margin-right: 8px;
            }
          }
          .star {
            display: flex;
            align-items: center;
            img {
              width: 24px;
              margin-right: 8px;
            }
          }
        }
        .game-tag {
          span {
            padding: 2px 6px;
            // background: #f8f8f8;
            border-radius: 22px;
            border: 0px solid #d2d2d2;
            font-weight: 600;
            font-size: 20px;
            color: #a2a2a2;
            // margin-right: 18px;
          }
          .other-tag {
            color: #ffbe70;
          }
        }
      }
    }

    .game-item-operate {
      span {
        display: block;
        width: 105px;
        height: 50px;
        border-radius: 25px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 28px;
        line-height: 50px;
        text-align: center;

        &:first-child {
          color: #ffffff;
          background: #ff7a3e;
          margin-bottom: 23px;
        }
        &:last-child {
          border: 2px solid #ff7a3e;
          color: #ff7a3e;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/myCollect/index.vue